var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.25V7.75H16.5V9.25H1.5ZM2.3625 4.7125L1.3875 4.15L2.025 3.025H0.75V1.9H2.025L1.3875 0.8125L2.3625 0.25L3 1.3375L3.6375 0.25L4.6125 0.8125L3.975 1.9H5.25V3.025H3.975L4.6125 4.15L3.6375 4.7125L3 3.5875L2.3625 4.7125ZM8.3625 4.7125L7.3875 4.15L8.025 3.025H6.75V1.9H8.025L7.3875 0.8125L8.3625 0.25L9 1.3375L9.6375 0.25L10.6125 0.8125L9.975 1.9H11.25V3.025H9.975L10.6125 4.15L9.6375 4.7125L9 3.5875L8.3625 4.7125ZM14.3625 4.7125L13.3875 4.15L14.025 3.025H12.75V1.9H14.025L13.3875 0.8125L14.3625 0.25L15 1.3375L15.6375 0.25L16.6125 0.8125L15.975 1.9H17.25V3.025H15.975L16.6125 4.15L15.6375 4.7125L15 3.5875L14.3625 4.7125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPassword);
export default __webpack_public_path__ + "static/media/resetPassword.a6f8b58ae1e4fa4b85765543f25f1a25.svg";
export { ForwardRef as ReactComponent };